<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">{{$route.name}}</h4>
						<!-- <p class="category">{{$route.name}}</p> -->
					</md-card-header>
					<md-card-content>
						<router-view />
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/ErrorPackages.vue